import { put, call, takeLatest, select } from 'redux-saga/effects';

import fbEmmiter from '../../../events/facebookEvents';
import { formatError } from '../../../libs';
import contactAPI from '../../api/contact';
import { Types, Creators as ContactCreators } from '../../reducers/contact';
import getState from '../../utils/getState';

function* sendContact({ data }) {
  try {
    const {
      app: { config = {} },
    } = yield select(getState);

    const { siteId } = config;

    const { id = null } = yield call(
      contactAPI.sendContact,
      {
        ...data,
        event_id: config.getIn(['notifyMe', 'contact']),
      },
      siteId
    );

    if (!id) {
      throw 'Ocorreu um erro ao enviar o contato, tente novamente mais tarde.';
    }

    yield put(ContactCreators.sendContactSuccess({ result: true }));

    fbEmmiter('Lead');
  } catch (error) {
    yield put(ContactCreators.sendContactError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.SEND_CONTACT_REQUEST, sendContact);
}
